import {
  getWorkspaceId,
  useAppSelector,
  useLazyGetInvoiceDetailsQuery,
} from '@zonofi/zono-money-store';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const useInvoiceDetails = () => {
  const params = useParams();

  const { invoiceId } = params;
  const [refreshNonce, setRefreshNonce] = useState(0);

  const workspaceId = useAppSelector(getWorkspaceId);

  const [fetchInvoiceApi, fetchInvoiceApiResponse] =
    useLazyGetInvoiceDetailsQuery();

  useEffect(() => {
    if (invoiceId) {
      fetchInvoiceApi({
        invoiceId,
        workspaceId,
      });
    }
  }, [invoiceId, workspaceId, refreshNonce]);

  const refresh = () => {
    setRefreshNonce((prev) => prev + 1);
  };

  return {
    invoiceDetailsRes: fetchInvoiceApiResponse,
    invoiceDetails: fetchInvoiceApiResponse?.data,
    invoiceDetailsLoading: fetchInvoiceApiResponse?.isLoading,
    invoiceDetailsError: fetchInvoiceApiResponse?.error,
    refresh,
  };
};
